import Reflux from "reflux";
import fetch from "logic/rest/FetchProvider";
import { singletonStore } from "logic/singleton";
import { qualifyUrl } from "util/URLUtils";
import FailureActions from "../actions/FailureActions";
const FailureStore = singletonStore(
  "FailureProcessing",
  () => Reflux.createStore({
    listenables: [FailureActions],
    updateFailureConfig(config) {
      const url = qualifyUrl("/plugins/org.graylog.plugins.failure/config");
      const promise = fetch("PUT", url, config);
      FailureActions.updateFailureConfig.promise(promise);
      return promise;
    },
    loadFailureConfig() {
      const url = qualifyUrl("/plugins/org.graylog.plugins.failure/config");
      const promise = fetch("GET", url);
      FailureActions.loadFailureConfig.promise(promise);
      return promise;
    },
    loadFailureProcessingOverview() {
      const url = qualifyUrl("/plugins/org.graylog.plugins.failure/failures/count");
      const promise = fetch("GET", url);
      FailureActions.loadFailureProcessingOverview.promise(promise);
      return promise;
    }
  })
);
export { FailureActions, FailureStore };
export default FailureStore;
